<template>
  <FormModal ref="ResponseListModal" title="Responses" id="list_response_modal" size="modal-xl">
    <ResponseList :responses="responses" :template="template" :currquestion="currquestion" ref="ResponseList" @select="selectResponse"  />
  </FormModal>
  
  <div class="bg-white py-1 px-2 mb-2 border-bottom">
  <div class="d-flex justify-content-between align-items-center mb-0">
    <div>
      <h3 class="mb-0 fw-bold">{{ template.name || 'Untitled Template' }}</h3>
      <small class="text-muted">#{{ template.doc_no || 'N/A' }}</small>
    </div>
    <button class="btn btn-primary py-2 px-4 form-submit-btn" :disabled="loading" @click="save_content()">
      <i class="fas fa-save"></i> {{ loading ? 'Loading...' : 'Save' }}
    </button>
  </div>
</div>
  <div class="builder">
    <div class="container-fluid">
      <LoadingBar v-if="loading" message="Loading Content..." />
      <div class="row">
        <div class="col-8 offset-2">
          <div class="builder-list">
            <div v-for="(item, index) in items" :key="item.id" class="builder-item">
              
              <!-- Heading -->
              <div v-if="item.type === 'heading'" class="heading-card">
                <div class="heading-content">
                  <i class="fas fa-heading"></i>
                  <input type="text" v-model="item.title" placeholder="Enter heading title">
                </div>
                <div class="heading-actions">
                  <button class="move-btn" @click="moveUp(index)" :disabled="index === 0" title="Move Up">
                    <i class="fas fa-arrow-up"></i>
                  </button>
                  <button class="move-btn" @click="moveDown(index)" :disabled="index === items.length - 1" title="Move Down">
                    <i class="fas fa-arrow-down"></i>
                  </button>
                  <button class="action-icon-btn" @click="duplicateItem(item.id)" title="Duplicate">
                    <i class="fas fa-copy"></i>
                  </button>
                  <button class="delete-btn" @click="deleteItem(item.id)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>

              <!-- Section -->
              <div v-else-if="item.type === 'section'" class="section-card">
                <div class="section-header">
                  <div class="section-title">
                    <i class="fas fa-layer-group text-muted"></i>
                    <input type="text" v-model="item.title" placeholder="Section Title">
                  </div>
                  <div class="section-actions">
                    <button class="move-btn" @click="moveUp(index)" :disabled="index === 0" title="Move Up">
                      <i class="fas fa-arrow-up"></i>
                    </button>
                    <button class="move-btn" @click="moveDown(index)" :disabled="index === items.length - 1" title="Move Down">
                      <i class="fas fa-arrow-down"></i>
                    </button>
                    <button class="action-icon-btn" @click="duplicateItem(item.id)" title="Duplicate">
                      <i class="fas fa-copy"></i>
                    </button>
                    <button class="action-icon-btn" @click="addQuestionToSection(item.id)" title="Add Question to Section">
                      <i class="fas fa-plus-circle"></i>
                    </button>
                    <button class="delete-btn" @click="deleteItem(item.id)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
                
                <div class="section-fields">
                  <div v-for="(question, qIndex) in item.get_content" :key="question.id" class="field-card">
                    <div class="question-row">
                      <input 
                        type="text" 
                        class="question-input" 
                        v-model="question.title" 
                        :placeholder="`Question ${qIndex + 1}`"
                      >
                      <span class="field-type-badge" @click="openCreateModal('ResponseListModal',question)">
                        <i v-if="getFieldTypeLabel(question).icon" :class="getFieldTypeLabel(question).icon"></i>
  {{ getFieldTypeLabel(question).name }}
                      </span>
                    </div>

                    <!-- <div class="content-area">
                      <div class="placeholder-content">
                        <i class="fa-regular fa-pen-to-square pe-1"></i>
                        <span> User's Input Will Be Here</span>
                      </div>
                    </div> -->

                    <div class="bottom-row">
                      <div class="bottom-left">
                        <label class="checkbox-label prop">
                          <input type="checkbox" v-model="question.required" >
                          <span class="checkmark"></span>
                          Required
                        </label>
                        <span class='text-muted'>/</span>
                        <label class='prop'>
                          <i class="fa-solid fa-code-merge"></i> Logics
                        </label>
                      </div>
                      <div class="bottom-right">
                        <button class="move-btn" @click="moveQuestionUp(item.id, qIndex)" :disabled="qIndex === 0" title="Move Up">
                          <i class="fas fa-arrow-up"></i>
                        </button>
                        <button class="move-btn" @click="moveQuestionDown(item.id, qIndex)" :disabled="qIndex === item.get_content.length - 1" title="Move Down">
                          <i class="fas fa-arrow-down"></i>
                        </button>
                        <button class="action-icon-btn" @click="duplicateQuestion(item.id, question.id)" title="Duplicate">
                          <i class="fas fa-copy"></i>
                        </button>
                        <button class="action-icon-btn" @click="deleteQuestion(item.id, question.id)" title="Delete">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="item.get_content.length === 0" class="empty-section">
                    <span>No questions in this section. Click + to add question.</span>
                  </div>
                </div>
              </div>

              <!-- Table -->
              <div v-else-if="item.type === 'table'" class="table-card">
                <div class="table-header">
                  <div class="table-title">
                    <i class="fas fa-table text-muted"></i>
                    <input type="text" v-model="item.title" placeholder="Table Title">
                  </div>
                  <div class="table-actions">
                    <button class="move-btn" @click="moveUp(index)" :disabled="index === 0" title="Move Up">
                      <i class="fas fa-arrow-up"></i>
                    </button>
                    <button class="move-btn" @click="moveDown(index)" :disabled="index === items.length - 1" title="Move Down">
                      <i class="fas fa-arrow-down"></i>
                    </button>
                    <button class="action-icon-btn" @click="duplicateItem(item.id)" title="Duplicate">
                      <i class="fas fa-copy"></i>
                    </button>
                    <button class="action-icon-btn" @click="addQuestionToTable(item.id)" title="Add Column to Table">
                      <i class="fas fa-plus-circle"></i>
                    </button>
                    <button class="delete-btn" @click="deleteItem(item.id)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
                
                <div class="table-fields">
                  <div v-for="(question, qIndex) in item.get_content" :key="question.id" class="field-card">
                    <div class="question-row">
                      <input 
                        type="text" 
                        class="question-input" 
                        v-model="question.title" 
                        :placeholder="`Column ${qIndex + 1}`"
                      >
                      <span class="field-type-badge" @click="openCreateModal('ResponseListModal', question)">
                        <i v-if="getFieldTypeLabel(question).icon" :class="getFieldTypeLabel(question).icon"></i>
  {{ getFieldTypeLabel(question).name }}
                      </span>
                    </div>

                    <!-- <div class="content-area">
                      <div class="placeholder-content">
                        <i class="fa-regular fa-pen-to-square pe-1"></i>
                        <span> Column {{ qIndex + 1 }} Input Will Be Here</span>
                      </div>
                    </div> -->

                    <div class="bottom-row">
                      <div class="bottom-left">
                        <label class="checkbox-label prop">
                          <input type="checkbox" v-model="question.required" >
                          <span class="checkmark"></span>
                          Required
                        </label>
                        <span class='text-muted'>/</span>
                         <div class='prop'>
                          <i class="fa-solid fa-code-merge"></i> Logics
                        </div>
                      </div>
                      <div class="bottom-right">
                        <button class="move-btn" @click="moveQuestionUp(item.id, qIndex)" :disabled="qIndex === 0" title="Move Up">
                          <i class="fas fa-arrow-up"></i>
                        </button>
                        <button class="move-btn" @click="moveQuestionDown(item.id, qIndex)" :disabled="qIndex === item.get_content.length - 1" title="Move Down">
                          <i class="fas fa-arrow-down"></i>
                        </button>
                        <button class="action-icon-btn" @click="duplicateQuestion(item.id, question.id)" title="Duplicate">
                          <i class="fas fa-copy"></i>
                        </button>
                        <button class="action-icon-btn" @click="deleteQuestion(item.id, question.id)" title="Delete">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="item.get_content.length === 0" class="empty-section">
                    <span>No columns in this table. Click + to add column.</span>
                  </div>
                </div>
              </div>

              <!-- Question (Level 1) -->
              <div v-else class="field-card">
                <div class="question-row">
                  <input 
                    type="text" 
                    class="question-input" 
                    v-model="item.title" 
                    :placeholder="`Question ${index + 1}`"
                  >
                  <span class="field-type-badge" @click="openCreateModal('ResponseListModal', item)">
                    <i v-if="getFieldTypeLabel(item).icon" :class="getFieldTypeLabel(item).icon"></i>
                    {{ getFieldTypeLabel(item).name }}
                  </span>
                </div>

                <!-- <div class="content-area">
                  <div class="placeholder-content">
                    <i class="fa-regular fa-pen-to-square pe-1"></i>
                    <span> User's Input Will Be Here</span>
                  </div>
                </div> -->

                <div class="bottom-row">
                  <div class="bottom-left">
                    <label class="checkbox-label prop">
                      <input type="checkbox" v-model="item.required" checked>
                      <span class="checkmark"></span>
                      Required 
                    </label>
                    <span class='text-muted'>/</span>
                      <div class='prop'>
                          <i class="fa-solid fa-code-merge"></i> Logics
                        </div>
                  </div>
                  
                  <div class="bottom-right">
                    <button class="move-btn" @click="moveUp(index)" :disabled="index === 0" title="Move Up">
                      <i class="fas fa-arrow-up"></i>
                    </button>
                    <button class="move-btn" @click="moveDown(index)" :disabled="index === items.length - 1" title="Move Down">
                      <i class="fas fa-arrow-down"></i>
                    </button>
                    <button class="action-icon-btn" @click="duplicateItem(item.id)" title="Duplicate">
                      <i class="fas fa-copy"></i>
                    </button>
                    <button class="action-icon-btn" @click="deleteItem(item.id)" title="Delete">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              
              <!-- Add between button with dropdown -->
              <!-- Add between button with dropdown -->
<div class="add-between-wrapper">
  <div class="custom-dropdown" @click.stop>
    <button class="add-between-dropdown" title="Add After" @click="toggleDropdown(index)" @blur="closeDropdown">
      <i class="fas fa-plus"></i>
    </button>
    <div v-if="activeDropdown === index" class="custom-dropdown-menu">
      <button class="custom-dropdown-item" @mousedown.prevent @click="addQuestionAfter(item.id); closeDropdown()">
        <i class="fas fa-square"></i> Question
      </button>
      <button class="custom-dropdown-item" @mousedown.prevent @click="addHeadingAfter(item.id); closeDropdown()">
        <i class="fas fa-heading"></i> Heading
      </button>
      <button class="custom-dropdown-item" @mousedown.prevent @click="addSectionAfter(item.id); closeDropdown()">
        <i class="fas fa-layer-group"></i> Section
      </button>
      <button class="custom-dropdown-item" @mousedown.prevent @click="addTableAfter(item.id); closeDropdown()">
        <i class="fas fa-table"></i> Table
      </button>
    </div>
  </div>
</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sticky Navigation Bar -->
    <div class="sticky-nav">
      <div class="nav-title">New Item</div>
      <div class="nav-buttons">
        <button class="nav-btn" @click="addQuestion">
          <i class="fas fa-square"></i> Field
        </button>
        <button class="nav-btn heading-nav" @click="addHeading">
          <i class="fas fa-heading"></i> Heading
        </button>
        <button class="nav-btn section-nav" @click="addSection">
          <i class="fas fa-layer-group"></i> Section
        </button>
        <button class="nav-btn table-nav" @click="addTable">
          <i class="fas fa-table"></i> Table
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import ResponseList from '@/views/Template/Includes/ResponseList.vue'

export default {
  name: 'Builder',
  data() {
    return {
      items: [],
      template: {},
      loading: false,
      responses: [],
      currquestion: {},
      activeDropdown: null
    }
  },
  components: {
    LoadingBar,
    FormModal,
    ResponseList,
  },
  mounted() {
    this.get_template()
  },
  methods: {
    toggleDropdown(index) {
    this.activeDropdown = this.activeDropdown === index ? null : index
  },
  closeDropdown() {
    this.activeDropdown = null
  },
    selectResponse(response) {
      if (this.currquestion && response) {
        const updateQuestion = (items) => {
          for (let item of items) {
            if (item.id === this.currquestion.id) {
              item.response_id = response.id
              item.get_response = response
              return true
            }
            if (item.get_content && item.get_content.length > 0) {
              for (let subItem of item.get_content) {
                if (subItem.id === this.currquestion.id) {
                  subItem.response_id = response.id
                  subItem.get_response = response
                  return true
                }
              }
            }
          }
          return false
        }
        updateQuestion(this.items)
        this.currquestion.response_id = response.id
        this.currquestion.get_response = response
        this.closeCreateModal('ResponseListModal')
      }
    },
    openCreateModal(ref, qt = {}) {
      if (ref == "ResponseListModal") {
        this.currquestion = qt;
      }
      this.$refs[ref].showModal()
    },
    closeCreateModal(ref) {
      this.$refs[ref].closeModal()
    },
    async save_content() {
      this.loading = true
      const result = await form_api_submit({
        url: 'template/builder/' + this.$route.params.id + "/save-content",
        method: 'POST',
        data: { "content": this.items },
        show_success_toast: false
      })
      if (result.success) {
        // success
      }
      this.loading = false
    },
    async get_responses() {
      const result = await form_api_submit({
        url: 'template/builder/response/list/' + this.template.external_id,
        method: 'GET',
        data: [],
        show_success_toast: false
      })
      if (result.success) {
        this.responses = result.data
      }
    },
    async get_template() {
      this.loading = true
      const result = await form_api_submit({
        url: 'template/builder/' + this.$route.params.id,
        method: 'GET',
        data: this.form,
        show_success_toast: false
      })
      if (result.success) {
        this.template = result.data
        this.items = this.template.get_content || []
        await this.get_responses()
      }
      this.loading = false
    },
    generateId() {
      return Date.now() + Math.random()
    },
    getFieldTypeLabel(qt) {
  if (qt.get_response && qt.get_response.name) {
    return {
      icon: qt.get_response.icon || 'fa-regular fa-rectangle-list',
      name: qt.get_response.name
    }
  }
  return {
    icon: null,
    name: 'Select Response'
  }
},
    addQuestion() {
      this.items.push({
        id: this.generateId(),
        type: 'question',
        title: '',
        field_type: 'text',
        required: false,
        response_id: null,
        get_response: {}
      })
    },
    addHeading() {
      this.items.push({
        id: this.generateId(),
        type: 'heading',
        title: ''
      })
    },
    addSection() {
      this.items.push({
        id: this.generateId(),
        type: 'section',
        title: '',
        get_content: []
      })
    },
    addTable() {
      this.items.push({
        id: this.generateId(),
        type: 'table',
        title: '',
        get_content: []
      })
    },
    addQuestionToSection(sectionId) {
      const section = this.items.find(i => i.id === sectionId)
      if (section && section.type === 'section') {
        section.get_content.push({
          id: this.generateId(),
          title: '',
          field_type: 'text',
          required: false,
          type: 'question',
          response_id: null,
          get_response: {}
        })
      }
    },
    addQuestionToTable(tableId) {
      const table = this.items.find(i => i.id === tableId)
      if (table && table.type === 'table') {
        table.get_content.push({
          id: this.generateId(),
          title: '',
          field_type: 'text',
          required: false,
          type: 'question',
          response_id: null,
          get_response: {}
        })
      }
    },
    addQuestionAfter(id) {
      const index = this.items.findIndex(i => i.id === id)
      this.items.splice(index + 1, 0, {
        id: this.generateId(),
        type: 'question',
        title: '',
        field_type: 'text',
        required: false,
        response_id: null,
        get_response: {}
      })
    },
    addHeadingAfter(id) {
      const index = this.items.findIndex(i => i.id === id)
      this.items.splice(index + 1, 0, {
        id: this.generateId(),
        type: 'heading',
        title: ''
      })
    },
    addSectionAfter(id) {
      const index = this.items.findIndex(i => i.id === id)
      this.items.splice(index + 1, 0, {
        id: this.generateId(),
        type: 'section',
        title: '',
        get_content: []
      })
    },
    addTableAfter(id) {
      const index = this.items.findIndex(i => i.id === id)
      this.items.splice(index + 1, 0, {
        id: this.generateId(),
        type: 'table',
        title: '',
        get_content: []
      })
    },
    duplicateItem(id) {
      const index = this.items.findIndex(i => i.id === id)
      const original = this.items[index]
      let copy
      if (original.type === 'section' || original.type === 'table') {
        copy = {
          ...original,
          id: this.generateId(),
          title: original.title ? `${original.title} (Copy)` : '',
          get_content: original.get_content.map(c => ({
            ...c,
            id: this.generateId(),
            title: c.title ? `${c.title} (Copy)` : ''
          }))
        }
      } else if (original.type === 'heading') {
        copy = {
          ...original,
          id: this.generateId(),
          title: original.title ? `${original.title} (Copy)` : ''
        }
      } else {
        copy = {
          ...original,
          id: this.generateId(),
          title: original.title ? `${original.title} (Copy)` : ''
        }
      }
      this.items.splice(index + 1, 0, copy)
    },
    deleteItem(id) {
      if (confirm('Delete this item?')) {
        this.items = this.items.filter(i => i.id !== id)
      }
    },
    duplicateQuestion(sectionId, questionId) {
      const section = this.items.find(i => i.id === sectionId)
      if (section) {
        const questionIndex = section.get_content.findIndex(q => q.id === questionId)
        const original = section.get_content[questionIndex]
        const copy = {
          ...original,
          id: this.generateId(),
          title: original.title ? `${original.title} (Copy)` : ''
        }
        section.get_content.splice(questionIndex + 1, 0, copy)
      }
    },
    deleteQuestion(sectionId, questionId) {
      if (confirm('Delete this question?')) {
        const section = this.items.find(i => i.id === sectionId)
        if (section) {
          section.get_content = section.get_content.filter(q => q.id !== questionId)
        }
      }
    },
    moveUp(index) {
      if (index > 0) {
        const temp = this.items[index]
        this.items[index] = this.items[index - 1]
        this.items[index - 1] = temp
      }
    },
    moveDown(index) {
      if (index < this.items.length - 1) {
        const temp = this.items[index]
        this.items[index] = this.items[index + 1]
        this.items[index + 1] = temp
      }
    },
    moveQuestionUp(sectionId, questionIndex) {
      const section = this.items.find(i => i.id === sectionId)
      if (section && questionIndex > 0) {
        const temp = section.get_content[questionIndex]
        section.get_content[questionIndex] = section.get_content[questionIndex - 1]
        section.get_content[questionIndex - 1] = temp
      }
    },
    moveQuestionDown(sectionId, questionIndex) {
      const section = this.items.find(i => i.id === sectionId)
      if (section && questionIndex < section.get_content.length - 1) {
        const temp = section.get_content[questionIndex]
        section.get_content[questionIndex] = section.get_content[questionIndex + 1]
        section.get_content[questionIndex + 1] = temp
      }
    }
  }
}
</script>

<style scoped>
.builder {
  background: #f8f9fa;
  min-height: 100vh;
  padding: 30px 0;
  position: relative;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.builder-header {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.add-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.heading-btn {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.section-btn {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.table-btn {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

/* Sticky Navigation */
.sticky-nav {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  padding: 16px;
  min-width: 140px;
  z-index: 1000;
  border: 1px solid #e0e0e0;
}

.nav-title {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-align: center;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.nav-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nav-btn {
  background: none;
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  color: #555;
}

.nav-btn:hover {
  background: #f8f9fa;
  transform: translateX(-3px);
}

.nav-btn i {
  width: 18px;
  font-size: 14px;
}

.nav-btn.heading-nav:hover {
  border-color: #f5576c;
  color: #f5576c;
}

.nav-btn.section-nav:hover {
  border-color: #43e97b;
  color: #43e97b;
}

.nav-btn.table-nav:hover {
  border-color: #fa709a;
  color: #fa709a;
}

/* Rest of your existing styles */
.builder-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.builder-item {
  position: relative;
}

/* Heading Card */
.heading-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  transition: all 0.2s;
}

.heading-card:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.heading-content {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.heading-content i {
  color: #f5576c;
  font-size: 20px;
}

.heading-content input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 18px;
  font-weight: 600;
  padding: 8px 0;
  background: transparent;
}

.heading-content input::placeholder {
  color: #bbb;
  font-weight: normal;
}

.heading-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Section Card */
.section-card {
  border: 1px solid lightgrey;
  border-radius: 12px;
  overflow: hidden;
}

.section-header {
  background: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d1fae5;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.section-title i {
  color: var(--primary-color, #667eea);
  font-size: 18px;
}

.section-title input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 0;
  background: transparent;
}

.section-title input::placeholder {
  color: #bbb;
  font-weight: normal;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-fields {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Table Card */
.table-card {
  border: 1px solid lightgrey;
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  background: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d1fae5;
}

.table-title {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.table-title i {
  color: #fa709a;
  font-size: 18px;
}

.table-title input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 0;
  background: transparent;
}

.table-title input::placeholder {
  color: #bbb;
  font-weight: normal;
}

.table-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-fields {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.empty-section {
  text-align: center;
  padding: 30px;
  color: #999;
  font-size: 13px;
  background: #fafafa;
  border-radius: 10px;
  border: 1px dashed #ddd;
}

.move-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  color: #888;
  transition: all 0.2s;
  font-size: 14px;
}

.move-btn:hover:not(:disabled) {
  background: #f0f0f0;
  color: #667eea;
}

.move-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  color: #888;
  transition: all 0.2s;
}

.delete-btn:hover {
  background: #fee;
  color: #dc3545;
}

/* Field Card */
.field-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.2s;
}

.field-card:hover {
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

/* Question Row */
.question-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.question-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  padding: 8px 0;
  background: transparent;
}

.question-input::placeholder {
  color: #bbb;
  font-weight: normal;
}

.field-type-badge:hover {
  background: #f0f0f0;
  transform: scale(1.1);
  cursor: pointer;
}

.field-type-badge {
  background: rgb(245, 245, 245);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  color: black;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 15px;
}

/* Content Area */
.content-area {
  background: #fafafa;
  border: 1px dashed #ddd;
  border-radius: 10px;
  padding: 10px 10px;
  text-align: center;
}

.placeholder-content {
  color: #999;
}

.placeholder-content span {
  font-size: 12px;
}

/* Bottom Row */
.bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding-top: 5px; */
  /* border-top: 1px solid #f0f0f0; */
}

.bottom-left {
  display: flex;
  align-items: center;
}

.bottom-left .prop
{
  font-size:11px !important;
  margin-left:7px !important;
  margin-right:7px !important;
  color:var(--primary-color, #667eea) !important;
  padding:2px 5px !important;
  border-radius:4px 4px;
}
.bottom-left .prop:hover{
  background-color:rgb(248,248,248);
  cursor:pointer
}

.bottom-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #555;
  position: relative;
  user-select: none;
}

.checkbox-label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  width: 18px;
  height: 18px;
  background: white;
  border: 2px solid #ddd;
  border-radius: 4px;
  display: inline-block;
  transition: all 0.2s;
}

.checkbox-label input:checked ~ .checkmark {
  background: #667eea;
  border-color: #667eea;
}

.checkbox-label input:checked ~ .checkmark:after {
  content: "✓";
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 14px;
}

.action-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  color: #888;
  transition: all 0.2s;
  font-size: 14px;
}

.action-icon-btn:hover {
  background: #f0f0f0;
  color: #667eea;
}

.action-icon-btn:last-child:hover {
  background: #fee;
  color: #dc3545;
}

/* Add between buttons with custom dropdown */
.add-between-wrapper {
  margin-top: 10px;
  text-align: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.custom-dropdown {
  position: relative;
  display: inline-block;
}

.add-between-dropdown {
  background: white;
  border: 1px dashed #ccc;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.add-between-dropdown:hover {
  background: #f9f9f9;
  border-color: #667eea;
  color: #667eea;
  transform: translateY(-2px);
}

.custom-dropdown-menu {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  min-width: 150px;
  padding: 4px 0;
  margin-bottom: 8px;
  z-index: 1000;
}

.custom-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #555;
  width: 100%;
  text-align: left;
  transition: all 0.2s;
}

.custom-dropdown-item:hover {
  background: #f5f5f5;
  color: #667eea;
}

.custom-dropdown-item i {
  width: 18px;
  font-size: 14px;
}

@media (max-width: 1024px) {
  .sticky-nav {
    display: none;
  }
}

@media (max-width: 640px) {
  .question-row {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .field-type-badge {
    margin-left: 0;
  }
  
  .builder-header {
    flex-direction: column;
  }
  
  .add-btn {
    justify-content: center;
  }
  
  .bottom-row {
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .section-header {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .table-header {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .add-between-wrapper {
    flex-wrap: wrap;
  }

  .custom-dropdown-menu {
    left: 50%;
    transform: translateX(-50%);
    min-width: 140px;
  }
}
</style>